/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Starting_InfoInputs */



/**
* | output |
* | --- |
* | "Syncing team project with Junction. This may take a moment..." |
*
* @param {Team_Sync_Starting_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_starting_info = /** @type {((inputs?: Team_Sync_Starting_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Starting_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation du projet d’équipe avec Junction. Cela peut prendre un moment...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Teamprojekt wird mit Junction synchronisiert. Dies kann einen Moment dauern…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sincronizzazione del progetto di gruppo con Junction. L'operazione potrebbe richiedere qualche istante...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Синхронизация командного проекта с Junction. Это может занять некоторое время...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sincronizando proyecto de equipo con Junction. Puede tardar un momento...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在将团队项目与 Junction 同步。这可能需要一些时间……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームプロジェクトをJunctionと同期しています。少々時間がかかる場合があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम प्रोजेक्ट को जंक्शन के साथ सिंक्रनाइज़ किया जा रहा है। इसमें थोड़ा समय लग सकता है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronizando o projeto da equipe com o Junction. Isso pode levar alguns instantes...")
	return /** @type {LocalizedString} */ ("Syncing team project with Junction. This may take a moment...")
});